export default ({ from, to, check }) => {
    if (!from || !to || !check) {
        return false;
    }
    const currentDate = check;
    const minDate = new Date(from);
    const maxDate = new Date(to);
    return currentDate > minDate && currentDate < maxDate;
};
